import { CloudMarketplace } from '../productsListing/types'

/** Search ranking / marketplace SEO is AWS-only. */
export const SEO_CLOUD_MARKETPLACE: CloudMarketplace = 'AWS'

export const competitorSuccessMessage = 'Competitors added successfully'
export const keywordSuccessMessage =
  'Keywords and competitors saved successfully'
